import "@fontsource-variable/sora";
import "@fontsource-variable/manrope";
import "@fontsource-variable/jetbrains-mono";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { AuthProvider, msalInstance } from "./lib/auth";
import { microsoftLoginEnabled } from "./lib/runtime";
import "./styles.css";

document.documentElement.dataset.theme = "light";
localStorage.removeItem("cv-theme");

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
    mutations: { retry: false },
  },
});

async function start(): Promise<void> {
  if (microsoftLoginEnabled) {
    await msalInstance.initialize();
    const response = await msalInstance.handleRedirectPromise();
    if (response?.account) msalInstance.setActiveAccount(response.account);
    else if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts()[0]) msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]!);
  }
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter><App /></BrowserRouter>
        </QueryClientProvider>
      </AuthProvider>
    </StrictMode>,
  );
}

void start();
